module.exports = __webpack_public_path__ + "static/img/1-1.46a3efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/1-1.png
// module id = 7lTQ
// module chunks = 10